export const VIEW_AS_PANEL = {
    HIDE_MSRP: "hide-msrp",
    HIDE_WHOLESALE: "hide-wholesale",
};
